import Box from '@mui/material/Box';
import React, { memo } from 'react';

import { grey } from '../../styles/mui/colors';

/**
 * BoxSeparator is a functional component that renders a separator box.
 * The separator box is styled to occupy the full width and has specific padding and margin.
 * It's commonly used to visually separate different sections of a layout.
 *
 * @returns {React.JSX.Element} A styled Box component from Material-UI
 * @constructor
 */
const BoxSeparatorComponent = () => <Box bgcolor={grey.grey5} py={1} width={1} />;

BoxSeparatorComponent.displayName = 'BoxSeparator';
const BoxSeparator = memo(BoxSeparatorComponent);

export default BoxSeparator;
